import moment from 'moment';
import Calendar from 'react-calendar';
import React from 'react'
import { Modal } from 'react-bootstrap';
import './style.css'

interface PropsCalender {
    calenderisvisisble: any,
    setCalenderIsVisisble: any,
    selectedDate: any,
    setSelectedDate: any
}

function MyVerticallyCenteredModal(props: any) {

    return (
        <Modal
            className='modelCal'
            show={props.calenderisvisisble}
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter">
            <Modal.Body >
                <div style={{ borderRadius: '0.5rem' }} >
                    <Calendar onChange={props.selectDate} value={props.selectedDate}
                        maxDate={new Date()}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
}

const Calender: React.FC<PropsCalender> = ({ calenderisvisisble, setCalenderIsVisisble, setSelectedDate, selectedDate }) => {
    const selectDateFunc = (date: any) => {
        setSelectedDate((moment(date).format('YYYY-MM-DD')))
        setCalenderIsVisisble(false)
    }

    return (
        <>
            <MyVerticallyCenteredModal selectDate={selectDateFunc} selectedDate={selectedDate} onHide={() => setCalenderIsVisisble(false)} calenderisvisisble={calenderisvisisble} />
        </>
    )
}




export default Calender
